export default {
  nodeEnv: process.env.NODE_ENV,
  baseApiUrl: process.env.VUE_APP_BASE_API_URL,
  baseSpaceCdnUrl: process.env.VUE_APP_BASE_SPACE_CDN_URL,
  toolsLoanEligibilityCalculatorUrl:
    process.env.VUE_APP_TOOLS_LOAN_ELIGIBILITY_CALCULATOR_URL,
};
